export const APP_LANGUAGES = ['az', 'en', 'tr'] as const;

export type AppLanguage = (typeof APP_LANGUAGES)[number];

/** Turkey and Azerbaijan pick a local language. Everywhere else stays English. */
export const languageFromCountry = (countryCode: string | null | undefined): AppLanguage => {
  const code = (countryCode ?? '').trim().toUpperCase();
  if (code === 'AZ') {
    return 'az';
  }

  if (code === 'TR') {
    return 'tr';
  }

  return 'en';
};

/**
 * Instant guess used before the country lookup returns. People in those countries
 * almost always have the matching timezone, so the first screen is already right.
 */
export const languageFromTimeZone = (timeZone: string | null | undefined): AppLanguage => {
  if (timeZone === 'Asia/Baku') {
    return 'az';
  }

  if (timeZone === 'Europe/Istanbul') {
    return 'tr';
  }

  return 'en';
};

export const readBrowserTimeZone = (): string => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || '';
  } catch {
    return '';
  }
};

export const lookupVisitorCountry = async (): Promise<string | null> => {
  const controller = new AbortController();
  const timer = window.setTimeout(() => controller.abort(), 2500);

  try {
    const response = await fetch('https://api.country.is/', { signal: controller.signal });
    if (!response.ok) {
      return null;
    }

    const body = (await response.json()) as { country?: unknown };
    const country = typeof body.country === 'string' ? body.country.trim().toUpperCase() : '';
    return /^[A-Z]{2}$/.test(country) ? country : null;
  } catch {
    return null;
  } finally {
    window.clearTimeout(timer);
  }
};
